import React from 'react';
import '../Estilos/Estilo.scss';
import { Paginacion,getCurrentPage } from '../util/paginacion';
import Spinner from "react-bootstrap/Spinner";


class EVENT extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id:props.id,
			event: props.event,
            currentPageevent:1,
            loadingevent:true,
            eventActuales:[],
            itemPerPage:props.item,
            vacia : false
            
		};
        if(this.state.event.length === 0){
            this.state.vacia = true;
        }
        
      }
    render(){
        return(	
        <div>
        <div>

        {this.state.vacia ? <h1>There are no current events to show</h1> : null}
        {this.setState({eventActuales:this.state.event.slice((this.state.currentPageevent - 1) * this.state.itemPerPage, this.state.currentPageevent * this.state.itemPerPage),loadingevent:false})}
        <div class='event-structure'>
            {this.state.loadingevent & !this.state.vacia ? <Spinner /> :
                this.state.eventActuales.map((
                    {title,eventDate, introduction, link, image,publicationDate})=>{		
                return(					
                    <div class='event-card' on >    
                    <table>
                            <tr><h1><a href={link}><b>{title}</b></a></h1>	</tr>
                            <tr><h4><b>Fecha: </b>{eventDate}</h4></tr>    
                            <tr>
                                <div class="description">  
                                    <p>{introduction}</p>
                                    
                                </div>
                            </tr>
                            <tr>
                                <div class="pie-card">
                                <b>Published: </b>{publicationDate}
                                </div></tr>
                        </table>
                        <div class="imagenes">
                            <a href={link}><img src={image} height="130px" width="180px" alt='Imagen del proyecto'/></a>
                        </div>
                    </div>  
                );
            
            })}
        </div> 
        </div>
        <Paginacion id={this.state.id} itemPerPage ={this.state.itemPerPage} length={this.state.event.length}/>
        {this.setState({currentPageevent:getCurrentPage(this.state.id)})}
        </div>
        );
        
    }
}

 export default EVENT;